import { render } from "./CustomDialog.vue?vue&type=template&id=f0bbfcba&scoped=true&ts=true"
import script from "./CustomDialog.vue?vue&type=script&lang=ts"
export * from "./CustomDialog.vue?vue&type=script&lang=ts"

import "./CustomDialog.vue?vue&type=style&index=0&id=f0bbfcba&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bbfcba"]])

export default __exports__